import { Form, Input } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'
import { useTranslation } from 'react-i18next'

const WaterDensitySection = ({
  disabled,
  validationRules,
  isArrivalDrafts,
}) => {
  const { t } = useTranslation()

  return (
    <div className="vessel-drafts-table__section">
      <Text className="vessel-drafts-table__section-title">
        {isArrivalDrafts
          ? t('portCall.draftSurvey.arrivalWaterDensity')
          : t('portCall.draftSurvey.departureWaterDensity')}
      </Text>

      <Form.Item
        label={t('portCall.draftSurvey.waterDensity')}
        name="waterDensity"
        rules={validationRules}
      >
        <Input
          addonAfter={t('portCall.draftSurvey.t/m3')}
          disabled={disabled}
          type="number"
        />
      </Form.Item>
    </div>
  )
}

WaterDensitySection.propTypes = {
  disabled: PropTypes.bool.isRequired,
  isArrivalDrafts: PropTypes.bool.isRequired,
  validationRules: PropTypes.array.isRequired,
}

export default WaterDensitySection
